
<script>import Loader from '/app/components/Loader.html'
// import { tween } from 'svelte-extras'

export default {

	data() {
		return {
			frozen: false,
		}
	},

	computed: {
		loaded: items => !!items,
		isSmallScreen: windowWidth => windowWidth < _MEDIA_SMALL ? true : false,
		eventsTransitionStyle: (isSmallScreen, windowWidth, eventsSelectedIndex) => {
			if (isSmallScreen) {
				const itemWidth = windowWidth - 60 + 15
				return `transform:translateX(${itemWidth * -eventsSelectedIndex}px)`
			}
			return ''
		},
		newsTransitionStyle: (isSmallScreen, windowWidth, newsSelectedIndex) => {
			if (isSmallScreen) {
				const itemWidth = windowWidth - 60 + 15
				return `transform:translateX(${itemWidth * -newsSelectedIndex}px)`
			}
			return ''
		},
		eventItems: items => _.filter(items, { type: 'event' }),
		newsItems: items => _.filter(items, { type: 'news' }),
	},

	oncreate() {
		// one time fetch
		fetch(this.get('url'))
			.then(response => response.json())
			.then(json => {
				// console.log(json)
				this.set({
					eventsSelectedIndex: 0,
					newsSelectedIndex: 0,
					items: json,
				})
			})
			// TODO: handle errors gracefully?
			// .catch(ex => console.log('parsing failed', ex))
	},

	components: {
		Loader,
	},

	methods: {
		// tween,
		freezeTransitions() {
			this.set({ frozen: true })
			this.debounceResizeEnd(this)
		},
		debounceResizeEnd: (() => {
			return _.debounce(function() {
				this.set({ frozen: false })
			}, 250)
		})(),
	},

}

</script><:Window on:resize="freezeTransitions()" bind:innerWidth="windowWidth"/>{{#if loaded}}{{#if isSmallScreen}}
<div class="responsive-carousel events-carousel is-small-screen {{frozen ? 'frozen' : ''}}">
  <div class="indices">{{#each eventItems as item, index}}
    <button class="{{index === eventsSelectedIndex ? 'on' : ''}}" on:click="set({ eventsSelectedIndex: index })">
      <div class="ghost">Carousel slide {{index}}</div>
    </button>{{/each}}
  </div>
  <div class="gutter">
    <div class="items grid-x grid-margin-x" style="{{eventsTransitionStyle}};">{{#each eventItems as item, index}}<a class="item cell medium-4 event {{index === eventsSelectedIndex ? 'on' : ''}}" href="{{item.url}}">
        <h3 class="date">{{item.formattedMonth}} <strong>{{item.formattedDay}}</strong></h3>
        <h4 class="item-title">{{item.title}}</h4>
        <p class="time">{{item.formattedTime}}</p>
        <p class="text">{{item.text}} </p></a>{{/each}}
    </div>
  </div>
  <div class="button-group"><a class="button" href="/all-events"><span>All {{itemsIndex === 0 ? 'Events' : 'News'}}</span></a></div>
</div>
<div class="responsive-carousel news-carousel is-small-screen {{frozen ? 'frozen' : ''}}">
  <div class="indices">{{#each newsItems as item, index}}
    <button class="{{index === newsSelectedIndex ? 'on' : ''}}" on:click="set({ newsSelectedIndex: index })">
      <div class="ghost">Carousel slide {{index}}</div>
    </button>{{/each}}
  </div>
  <div class="gutter">
    <div class="items grid-x grid-margin-x" style="{{newsTransitionStyle}};">{{#each newsItems as item, index}}<a class="item cell medium-4 news {{index === newsSelectedIndex ? 'on' : ''}}" style="background-image:url({{item.imgSrc}});" href="{{item.url}}">
        <div class="ghost">{{item.imgAlt}}</div>
        <div class="fold">
          <h2 class="item-title">{{item.title}}</h2>
          <h3 class="date">{{item.formattedDate}}</h3>
        </div></a>{{/each}}
    </div>
  </div>
  <div class="button-group"><a class="button" href="/all-events"><span>All {{itemsIndex === 0 ? 'Events' : 'News'}}</span></a></div>
</div>{{else}}
<div class="responsive-carousel {{frozen ? 'frozen' : ''}}">
  <div class="gutter">
    <div class="items grid-x grid-margin-x">{{#each items as item, index}}{{#if item.type === 'event'}}<a class="item cell medium-4 event" href="{{item.url}}">
        <h3 class="date">{{item.formattedMonth}} <strong>{{item.formattedDay}}</strong></h3>
        <h4 class="item-title">{{item.title}}</h4>
        <p class="time">{{item.formattedTime}}</p>
        <p class="text">{{item.text}} </p></a>{{else}}<a class="item cell medium-4 news" style="background-image:url({{item.imgSrc}});" href="{{item.url}}">
        <div class="ghost">{{item.imgAlt}}</div>
        <div class="fold">
          <h3 class="item-title">{{item.title}}</h3>
          <h4 class="date">{{item.formattedDate}}</h4>
        </div></a>{{/if}}{{/each}}
    </div>
  </div>
</div>{{/if}}{{else}}
<Loader></Loader>{{/if}}